import { createFileRoute } from "@tanstack/react-router";
import PromptTemplateEditorPage from "@/features/prompt-templates/pages/prompt-template-editor-page";

export const Route = createFileRoute("/_admin/prompt-engine/templates/new")({
  component: () => <PromptTemplateEditorPage />,
});
